import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AppProvider } from './context/AppContext';
import { DatabaseProvider } from './context/DatabaseContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AddCustomer from './pages/AddCustomer';
import ViewCustomers from './pages/ViewCustomers';
import CreateInvoice from './pages/CreateInvoice';
import InvoiceHistory from './pages/InvoiceHistory';
import PrintInvoice from './pages/PrintInvoice';
import AddTransaction from './pages/AddTransaction';
import ViewTransactions from './pages/ViewTransactions';
import TransactionHistory from './pages/TransactionHistory';
import Settings from './pages/Settings';
import TestConnection from './pages/TestConnection';

function App() {
  return (
    <AppProvider>
      <DatabaseProvider>
        <Router>
        <div className="App">
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                theme: {
                  primary: '#4aed88',
                },
              },
            }}
          />
          
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="add-customer" element={<AddCustomer />} />
              <Route path="customers" element={<ViewCustomers />} />
              <Route path="create-invoice" element={<CreateInvoice />} />
              <Route path="invoice-history" element={<InvoiceHistory />} />
              <Route path="add-transaction" element={<AddTransaction />} />
              <Route path="transactions" element={<ViewTransactions />} />
              <Route path="transaction-history" element={<TransactionHistory />} />
              <Route path="settings" element={<Settings />} />
              <Route path="test-connection" element={<TestConnection />} />
            </Route>
            
            <Route path="/print-invoice/:id" element={
              <ProtectedRoute>
                <PrintInvoice />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
        </Router>
      </DatabaseProvider>
    </AppProvider>
  );
}

export default App;
